import { PlusIcon } from "../../../../../assets/svgIcons";
import { RoutedModal } from "../../../../common";
import primaryComponents from "../../../../primaryComponents";
import { ContactList } from "../ContactList";
import { useAudienceForm } from "./useAudienceForm";
import { useValidation } from "./useValidation";

export const AudienceForm = ({ closeModal = () => {} }) => {
  const {
    isLoading,
    formData,
    isCustomerView,
    setIsCustomerView,
    setFormData,
    handleSubmitAudience,
  } = useAudienceForm({ closeModal });
  const {
    control,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useValidation({ ...formData });

  return (
    <>
      <div>
        <primaryComponents.InputFieldV2
          control={control}
          name="title"
          label="Title"
          placeholder={"Enter title"}
          classNames="white"
          value={formData?.title}
          errorMessage={errors?.title}
          onKeyUp={() => errors?.title && trigger("title")}
          onChange={({ target: { value } }) => {
            setFormData((prev) => ({ ...prev, title: value }));
          }}
        />

        <primaryComponents.TextAreaV2
          control={control}
          name="description"
          label="Description"
          placeholder={"Enter description"}
          value={formData?.description}
          onChange={({ target: { value } }) => {
            setFormData((prev) => ({ ...prev, description: value }));
          }}
        />

        {formData?.select_all_customers ? (
          <></>
        ) : formData?.customer_ids?.length ? (
          <>
            <p>{formData?.customer_ids?.length} customers selected</p>
          </>
        ) : null}

        <primaryComponents.Button
          classNames={"btn btn--outline smallBtn mx-auto my-4"}
          style={{ borderRadius: "25px" }}
          onClick={() => setIsCustomerView(true)}
        >
          <PlusIcon classNames="mr-1" /> Select Customers
        </primaryComponents.Button>

        <primaryComponents.Button
          classNames={"btn btn--primary w-100"}
          isDisabled={isLoading}
          isLoading={isLoading}
          loadingText={"Creating..."}
          onClick={handleSubmit(handleSubmitAudience)}
        >
          Create Audience Group
        </primaryComponents.Button>
      </div>

      <RoutedModal
        isActive={isCustomerView}
        width={700}
        closeModal={() => setIsCustomerView(false)}
        headerTitle="Select Customers"
      >
        <ContactList formData={formData} setFormData={setFormData} />
      </RoutedModal>
    </>
  );
};
